<user-login-or-register [showLogin]="true"></user-login-or-register>
